import $ from './jquery.js';
    
$('body').on('click', '[data-toggle-focus]', function(e) {
    e.preventDefault();
    var target = $($(this).data('toggle-focus'));
    target.focus();
});
